<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    :transform-data="transformData"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text="{ editable, viewOnly, form }">
      {{ getTitle(editable || viewOnly, form) }}
    </template>

    <template #default="{ editable, viewOnly, form }">
      <PublicationMunMehForm
        :form="form"
        :publication="publication"
        :disabled="editable || viewOnly"
      />
    </template>

    <template #footer-right="{ close: c, form }">
      <v-btn text @click="createFormTemplate(form)" v-text="'Создать шаблон формы'" />

      <v-btn text @click="c" v-text="'Отменить'" />
    </template>
  </BModalForm>
</template>

<script>
import { PublicationMunMehModel as Model } from '../Model'

import BModalForm from '@/components/modals/BModalForm.vue'
import PublicationMunMehForm, { createDefaultData } from './PublicationMunMehForm.vue'
import moment from 'moment'
import { MunMehApi } from '@/api/resources'


export default {
  name: 'PublicationMunMehModal',
  components: {
    BModalForm,
    PublicationMunMehForm,
  },
  inheritAttrs: false,
  props: {
    publication: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
          && 'start_at' in prop
          && 'end_at' in prop
          && 'participants' in prop
      ),
    },
  },
  data: (vm) => ({
    createDefaultData: () => createDefaultData(
      vm.publication.start_at,
      vm.publication.end_at,
    ),
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    getTitle(editable, form) {
      if (editable) return Model.page_title.view(form)
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
    transformData(data) {
      return {
        ...data,
        year: moment(data.start_at).format('YYYY'),
      }
    },
    async createFormTemplate(form) {
      const api = new MunMehApi()
      try {
        await api.createFormTemplate(form.id)
        this.$notice.create({ type: 'success', text: 'Запрос на генерацию успешно отправлен' })
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
